import { render, staticRenderFns } from "./LoggingLoader.vue?vue&type=template&id=00c24fa4"
import script from "./LoggingLoader.vue?vue&type=script&lang=js"
export * from "./LoggingLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports